// Localized names for the seeded Belgian public holidays. The migration
// stores them in French; this map lets the calendar display them in the
// user's chosen language. Unknown titles fall back to the stored value.
const TRANSLATIONS = {
  "Jour de l'An":          { fr: "Jour de l'An",          nl: 'Nieuwjaar',                    en: "New Year's Day" },
  'Lundi de Pâques':       { fr: 'Lundi de Pâques',       nl: 'Paasmaandag',                  en: 'Easter Monday' },
  'Fête du Travail':       { fr: 'Fête du Travail',       nl: 'Dag van de Arbeid',            en: 'Labour Day' },
  'Ascension':             { fr: 'Ascension',             nl: 'O.L.H. Hemelvaart',            en: 'Ascension Day' },
  'Lundi de Pentecôte':    { fr: 'Lundi de Pentecôte',    nl: 'Pinkstermaandag',              en: 'Whit Monday' },
  'Fête nationale belge':  { fr: 'Fête nationale belge',  nl: 'Belgische Nationale Feestdag', en: 'Belgian National Day' },
  'Assomption':            { fr: 'Assomption',            nl: 'O.L.V. Hemelvaart',            en: 'Assumption' },
  'Toussaint':             { fr: 'Toussaint',             nl: 'Allerheiligen',                en: "All Saints' Day" },
  'Armistice':             { fr: 'Armistice',             nl: 'Wapenstilstand',               en: 'Armistice Day' },
  'Noël':                  { fr: 'Noël',                  nl: 'Kerstmis',                     en: 'Christmas Day' },
};

export function holidayLabel(title, locale) {
  return TRANSLATIONS[title]?.[locale] || title;
}

export function eventLabel(event, locale) {
  if (event?.kind === 'public_holiday') return holidayLabel(event.title, locale);
  return event?.title || '';
}
